import React from "react";
import { FileText, CalendarDays } from "lucide-react";
import StatusBadge from "../../shared/components/StatusBadge";

const ContractsTab = ({ contracts = [] }) => {
  return (
    <div className="space-y-4 p-5">
      {contracts.length > 0 ? (
        contracts.map((contract) => (
          <div
            key={contract.uuid}
            className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <FileText size={16} className="text-purple-600" />
                <span className="text-sm font-semibold text-slate-800">
                  {contract.contract_number}
                </span>
              </div>
              <StatusBadge status={contract.status} />
            </div>

            <div className="mt-4 grid grid-cols-2 gap-4 border-t border-slate-50 pt-3 text-xs">
              <div>
                <p className="text-slate-400 font-medium">Contract Type</p>
                <p className="mt-1 font-semibold text-slate-700">
                  {contract.contract_type || "Employment Contract"}
                </p>
              </div>

              <div>
                <p className="text-slate-400 font-medium">Duration</p>
                <p className="mt-1 font-semibold text-slate-700 flex items-center gap-1.5">
                  <CalendarDays size={13} className="text-slate-400" />
                  <span>
                    {formatDate(contract.start_date)} -{" "}
                    {contract.end_date ? formatDate(contract.end_date) : "Indefinite"}
                  </span>
                </p>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="flex min-h-[200px] items-center justify-center">
          <div className="text-center">
            <p className="text-sm font-medium text-slate-700">No contracts found</p>
            <p className="mt-1 text-xs text-slate-400">
              There are no employment contracts available.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

const formatDate = (date) => {
  if (!date) return "—";
  const parsedDate = new Date(date);
  if (Number.isNaN(parsedDate.getTime())) return date;
  return parsedDate.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export default ContractsTab;